
import { defineComponent } from "vue";

export default defineComponent({
  name: "ConditionsOfThisAuthority",
  props: {
    usesGenericWording: { type: Boolean, default: false },
  },
});
